import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormControlName } from '@angular/forms';
import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthService } from '../token-interceptor/auth.service';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetComponent implements OnInit {

  public formSubmitted = false;

  public resetForm = this.fb.group({
    usuario: [ ''],
    clave: ['' , Validators.required],
    nuevaClave: ['' , Validators.required],
    confirmarClave: ['' , Validators.required]
  });


  constructor(
              private router: Router,
              private fb: FormBuilder,
              private loginService: LoginService,
              private authservice: AuthService
  ) { }

  ngOnInit(): void {
    const tokenUser = this.authservice.getToken();
    this.resetForm.get('usuario').setValue(tokenUser);
    console.log(tokenUser)
  }

  onReset(){
    this.formSubmitted = true;
    console.log(this.resetForm.value);

    if (this.resetForm.invalid) {
      console.log('El formulario no es correcto');
      Swal.fire('Error', 'Debe completar todos los campos', 'error');
      return;
    }

    if (this.resetForm.get('nuevaClave').value.length < 6 ){
      Swal.fire('Alerta', 'Las contraseña deben contener al menos 6 caracteres', 'error');
      return;
    }

    if (this.resetForm.get('nuevaClave').value !== this.resetForm.get('confirmarClave').value){
      Swal.fire('Alerta', 'Las contraseñas deben ser iguales', 'error');
      return;
    }

    this.loginService.CambiarContraseña(this.resetForm.value)
    .subscribe ( resp => {
      console.log(resp);
      if (resp.datos.length) {
        this.router.navigate(['/menu']);
      } else {
        Swal.fire('Alerta', resp.mensaje.error , 'error');
      }
    }, (err) => {
      console.log(err);
      Swal.fire('Alerta', 'Error de ingreso', 'error');
    });
  }


}
